import { useAuthorizeContext } from '../AuthorizeContext';
import { AcfFallbackBase } from './AcfFallbackBase';
import { getClientDisplayNameInSentence } from 'utils/connect-branding';

export const AcfFallback = () => {
  const { client, payrollProvider, nextStep } = useAuthorizeContext() || {};
  const displayName = getClientDisplayNameInSentence(client);

  return (
    <AcfFallbackBase
      heading={
        <>
          {payrollProvider?.displayName} requires a quick manual setup to
          complete your connection. You&apos;ll need to add {displayName} as an
          admin user in your {payrollProvider?.displayName} account &mdash;
          we&apos;ll walk you through it.
        </>
      }
      infoText="This takes about 2 minutes. You'll be able to access step-by-step instructions on the next screen."
      onNext={nextStep}
    />
  );
};
